import { render, staticRenderFns } from "./UserCell.vue?vue&type=template&id=78fffed6&"
import script from "./UserCell.vue?vue&type=script&lang=babel&"
export * from "./UserCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports